import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from "@/components/ui/accordion";
import { Switch } from "@/components/ui/switch";
import { useState } from "react";

interface Props {
	checked: boolean;
	onCheckedChange: (checked: boolean) => void;
}

const UpdateAllCheckbox = ({ checked, onCheckedChange }: Props) => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<div className="flex items-start space-x-2">
			<Switch
				id="update-all"
				checked={checked}
				onCheckedChange={onCheckedChange}
				className="mt-5"
			/>
			<Accordion
				type="single"
				collapsible
				className="w-full"
				value={isOpen ? "item-1" : ""}
				onValueChange={(value) => setIsOpen(value === "item-1")}
			>
				<AccordionItem value="item-1" className="border-none">
					<AccordionTrigger className="text-muted-foreground text-sm hover:no-underline">
						Update all diaries using this intervention
					</AccordionTrigger>
					<AccordionContent className="text-muted-foreground text-sm">
						<p className="mb-2">
							This value is linked to other diaries and events. You have two
							options:
						</p>
						<ul className="space-y-1 pl-4 list-disc">
							<li>
								<strong>Update all (recommended):</strong> This will update the
								value across all linked diaries and events, keeping everything
								in sync.
							</li>
							<li>
								<strong>Update this only:</strong> This will only update the
								value for this diary/event, leaving other linked items
								unchanged. This might lead to inconsistencies between different
								diaries or events.
							</li>
						</ul>
					</AccordionContent>
				</AccordionItem>
			</Accordion>
		</div>
	);
};

export default UpdateAllCheckbox;
